import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusSurvey = () => {
  return (
    <SettingsMetaData propertyName={"Status_Survey"} viewPropertyName={"Status"} />
  );
};
export default StatusSurvey;